module.exports = __webpack_public_path__ + "static/banner_home_desktop2-879de38ef35f3cf0ed58f4eb1c8d5780.jpg";